import { motion } from "framer-motion";
import { ShieldCheck, Headphones, Wrench } from "lucide-react";

export const FadeIn = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, desc }) => (
  <FadeIn className="max-w-3xl">
    <p className="flex items-center gap-4 text-[11px] font-bold uppercase tracking-[0.3em] text-brand">
      <span className="h-px w-10 bg-brand" aria-hidden="true" />
      {eyebrow}
    </p>
    <h2 className="mt-5 font-display text-4xl md:text-6xl font-semibold uppercase leading-[1.02] tracking-tight text-white">
      {title}
    </h2>
    {desc && (
      <p className="mt-5 text-base md:text-lg leading-relaxed text-zinc-400">
        {desc}
      </p>
    )}
  </FadeIn>
);
